module.exports = __webpack_public_path__ + "img/terroir-liquify-3-mobile.2f88a718.jpg";